// utils/resize-observer.ts
import { throttle } from 'lodash';

const OriginalResizeObserver = window.ResizeObserver;
let isProcessing = false;
const entryQueue: ResizeObserverEntry[][] = [];

class DebouncedResizeObserver {
    private observer: ResizeObserver;

    constructor(callback: (entries: ResizeObserverEntry[]) => void) {
        const processEntries = (entries: ResizeObserverEntry[]) => {
            // 将条目添加到队列
            entryQueue.push(entries);

            // 如果已经在处理中，则等待当前处理完成
            if (isProcessing) return;

            isProcessing = true;

            // 使用微任务批量处理队列中的所有条目
            Promise.resolve().then(() => {
                // 合并所有队列中的条目，过滤重复项
                const mergedEntries = [...new Set(entryQueue.flat())];
                entryQueue.length = 0; // 清空队列

                if (mergedEntries.length > 0) {
                    try {
                        callback(mergedEntries);
                    } catch (error) {
                        console.error('ResizeObserver 处理错误:', error);
                    }
                }

                isProcessing = false;

                // 如果在处理期间又有新条目加入，继续处理
                if (entryQueue.length > 0) {
                    processEntries([]); // 传入空数组以触发下一轮处理
                }
            });
        };

        // 使用节流限制调用频率
        const throttledProcess = throttle(processEntries, 150, {
            leading: false,
            trailing: true
        });

        this.observer = new OriginalResizeObserver(throttledProcess);
    }

    // 代理原始方法
    observe(target: Element) {
        this.observer.observe(target);
    }

    unobserve(target: Element) {
        this.observer.unobserve(target);
    }

    disconnect() {
        this.observer.disconnect();
        entryQueue.length = 0; // 清空队列
        isProcessing = false;
    }
}

window.ResizeObserver = DebouncedResizeObserver as any;
export { OriginalResizeObserver };
export default DebouncedResizeObserver;
